export default function isStringifiedJSONObject(value) {
  if (typeof value !== 'string') {
    return false;
  }

  return !!value.match(/{(.*?:.*?)}/g);
}
